module.exports = __webpack_public_path__ + "media/images/icon_a8_blue-2c0e3bd15112bd374b2f4d9f93d3a0ce.png";